import React, { useEffect, useState } from 'react'
import { Confirm } from '../../Confirmation/Confirm';

import { gql, useMutation } from '@apollo/client';
import { ErrorToast, SuccessToast } from '../../ToastComponent/RectHotToast';
import { useSelector } from 'react-redux';
import { ClearSpecificForm } from '../../../../Store/FormDataReducer/FormFieldFunctions';
import { useDispatch } from 'react-redux';
const LockLoadReceipt = gql`
mutation LockFtlPtlLoadReceipt($input: [lockPtlFtlLoadReceiptInput]) {
  LockFtlPtlLoadReceipt(input: $input) {
    message
   
  }
}
`;
// {
//   "input": [
//     {
//       "Is_Lock": false,
//       "id": "687747cb38cdd3e7ef4b2f52",
//       "type": "PTL"
//     }
//   ]
// }

const AddConsignmentNoteRegister = ({ show,
    id,
    TypeOfPortal,
    submitType,
    ParentPortalCloseFunction, }) => {
    let Form_Key = "Consignment_Note_Register"
    const [lockLoadReceipt, { loading: LockLoading }] = useMutation(LockLoadReceipt, {
        context: {
            headers: {
                "X-GraphQL-Server": "orion",
            },
        },
    });
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggle, settoggle] = useState(show ? show : false);
    const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
    const dispatch = useDispatch();

    useEffect(() => {
        setSelectedRows(fielddataRedux?.Consignment_Note_Register?.Selected_Rows);
    }, [fielddataRedux]);

    const Closeformfunction = () => {
        ClearSpecificForm(dispatch, Form_Key);
        settoggle(false);
        ParentPortalCloseFunction();
    };

    let handleLockRecords = async () => {
        await lockLoadReceipt({
            variables: {
                input: selectedRows?.map((el) => {
                    return {
                        Is_Lock: TypeOfPortal == "Lock" ? true : false,
                        id: el._id,
                        type: el.Type,
                    }
                }),

            },
        })
            .then((res) => {
                dispatch({ type: "Refetch", payload: true });
                SuccessToast(`Consignment Note(LRs) ${TypeOfPortal} Successfully`);
                Closeformfunction();
            })
            .catch((err) => {
                ErrorToast(err.message);
            });
    }

    if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock") {
        return (
            <>
                <Confirm
                    submitType={`Confirm ${TypeOfPortal}`}
                    submit={handleLockRecords}
                    settoggle={settoggle}
                    toggle={toggle}
                    loadingState={LockLoading}
                    message={`Are You Sure You Want to ${TypeOfPortal} this Record?`}
                />
            </>
        );
    }
    return (<></>)
}

export default AddConsignmentNoteRegister